import axios from 'axios'
const state = () => ({
    events: []
})

const getters = {
    events(state) {
        return state.events
    }
}

const mutations = {
    SET_EVENTS(state, payload){
        state.events = payload
    },
}

const actions = {
    getEvents({commit}){
        axios.get(`https://rtam.uz/api/events/getAll`)
            .then((res)=>{
                commit("SET_EVENTS", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
    getEventsById({commit}, id){
        axios.get(`https://rtam.uz/api/events/${id}`)
            .then((res)=>{
                commit("SET_EVENTS", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
